import React from 'react'
import styled from 'styled-components'
// import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Pagination, Scrollbar, A11y } from 'swiper'
SwiperCore.use([Pagination, Scrollbar, A11y])
import Banner from '@/components/home/banner'

interface Iprops {
  isFromMobile: boolean
}

const BannerBox = (props: Iprops) => {
  return (
    <Box>
      <div className="items">
        {/* <Swiper pagination={{ clickable: true }} scrollbar={{ draggable: true }}> */}
        {/* <SwiperSlide> */}
        <Banner isMobile={props.isFromMobile}></Banner>
        {/* </SwiperSlide> */}
        {/* <SwiperSlide>
            <div className="test"></div>
          </SwiperSlide> */}
        {/* </Swiper> */}
      </div>
    </Box>
  )
}

export default BannerBox

const Box = styled.div`
  @media only screen and (max-width: 1000px) {
    padding-top: 62px;
    .test {
      height: 458px;
    }
  }
  @media only screen and (min-width: 1000px) {
    max-width: 1440px;
    margin: 100px auto 0;
    .test {
      height: 612px;
    }
  }
  .test {
    width: 100%;
    background-color: #ccc;
  }
  .dd {
    background-color: green;
  }
`
